import { render, staticRenderFns } from "./selectCompuesto3.vue?vue&type=template&id=a039fa2e"
import script from "./selectCompuesto3.vue?vue&type=script&lang=js"
export * from "./selectCompuesto3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports